import React, { forwardRef } from 'react';
import { Form as AntForm } from 'antd';
import { Item } from './item';
import classNames from 'classnames';
import { ConfigProvider } from 'antd';

/**
 * A form component
 *
 * {@link https://ant.design/components/form#api}
 *
 * @module Form
 * @param {Object} props - the component props
 * @param {React.ReactNode} [props.children] - the children to render under the form
 * @param {boolean} [props.disabled] - whether or not the form is disabled
 * @param {Object} [props.restProps] - extra props for antd form component
 * @returns {React.ReactElement} - A form component
*/
const Form = forwardRef( ( props, ref ) => {
    const { children, disabled, className, ...restProps } = props;
    const classes = classNames( {
        disabled: disabled ? true : false,
        [ className ]: className ? true : false
    } );
    return (
        <ConfigProvider theme={
            {
                token: {
                    screenSM: 576,
                    screenSMMin: 576,
                    screenSMMax: 735,
                    screenMD: 736,
                    screenMDMin: 736,
                    screenMDMax: 1087,
                    screenLG: 1088,
                    screenLGMin: 1088,
                    screenLGMax: 1407,
                    screenXL: 1408,
                    screenXLMin: 1408,
                    screenXLMax: 1949,
                    screenXXL: 1950,
                    screenXXLMin: 1950,
                    screenXXLMax: 9999
                }
            }
        }>
            <AntForm className={ classes } ref={ ref } { ...restProps } disabled={ disabled } >{ children }</AntForm>
        </ConfigProvider>
        );
} );

Form.Item = Item;

Form.Item.useStatus = AntForm.Item.useStatus;

Form.useForm = AntForm.useForm;
Form.List = AntForm.List;
Form.ErrorList = AntForm.ErrorList;
Form.useFormInstance = AntForm.useFormInstance;
Form.useWatch = AntForm.useWatch;
Form.Provider = AntForm.Provider;

export { Form };
